import React, { useEffect, useMemo, useState } from "react";

const API = "/api/udrzba";

function normalizeArray(arr) {
  return Array.isArray(arr)
    ? arr.map((x) => String(x || "").trim()).filter(Boolean)
    : [];
}

export default function UdrzbaGallerySection() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openIndex, setOpenIndex] = useState(null);
  const [activeTab, setActiveTab] = useState("after");

  useEffect(() => {
    let alive = true;

    async function load() {
      try {
        setLoading(true);
        const res = await fetch(`${API}/galerie`, { method: "GET" });
        const data = await res.json().catch(() => null);
        const arr = Array.isArray(data?.items) ? data.items : [];

        const normalized = arr
          .map((item, index) => {
            const fotoPred = normalizeArray(item?.fotoPred);
            const fotoPo = normalizeArray(item?.fotoPo);

            const before = String(item?.before || "").trim() || fotoPred[0] || "";
            const after = String(item?.after || "").trim() || fotoPo[0] || "";
            const cover = String(item?.cover || "").trim() || after || before || "";

            return {
              id: String(item?.id || `gallery-${index + 1}`),
              title: String(item?.title || "Ukázka péče"),
              subtitle: String(item?.subtitle || ""),
              cover,
              before,
              after,
              fotoPred,
              fotoPo,
            };
          })
          .filter((x) => x.cover || x.before || x.after);

        if (alive) setItems(normalized);
      } catch (_) {
        if (alive) setItems([]);
      } finally {
        if (alive) setLoading(false);
      }
    }

    load();
    return () => {
      alive = false;
    };
  }, []);

  const activeItem = useMemo(() => {
    if (openIndex === null) return null;
    return items[openIndex] || null;
  }, [openIndex, items]);

  const activeImage = activeItem
    ? (activeTab === "before" ? activeItem.before : activeItem.after)
    : "";

  return (
    <>
      <div
        style={{
          marginBottom: 26,
          padding: 22,
          borderRadius: 22,
          border: "1px solid #dbe7f5",
          background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
          boxShadow: "0 12px 30px rgba(15,23,42,0.05)",
        }}
      >
        <div style={{ fontSize: 26, fontWeight: 800, color: "#0f172a", marginBottom: 8 }}>
          Ukázky mé práce
        </div>

        <div style={{ color: "#64748b", lineHeight: 1.7, marginBottom: 18, fontSize: 16 }}>
          Reálné ukázky údržby hrobů před a po provedení práce.
          Kliknutím na fotku otevřete detail před / po.
        </div>

        {loading ? (
          <div style={{ color: "#64748b", fontSize: 15 }}>Načítám galerii…</div>
        ) : items.length === 0 ? (
          <div
            style={{
              padding: 18,
              borderRadius: 16,
              background: "#f8fafc",
              border: "1px solid #e2e8f0",
              color: "#475569",
            }}
          >
            Galerie je zatím prázdná.
          </div>
        ) : (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
              gap: 18,
            }}
          >
            {items.map((item, index) => (
              <button
                key={item.id}
                type="button"
                onClick={() => {
                  setOpenIndex(index);
                  setActiveTab(item.after ? "after" : "before");
                }}
                style={{
                  textAlign: "left",
                  border: "1px solid #dbe7f5",
                  borderRadius: 20,
                  padding: 0,
                  background: "#fff",
                  cursor: "pointer",
                  overflow: "hidden",
                  boxShadow: "0 10px 24px rgba(15,23,42,0.06)",
                }}
              >
                <div
                  style={{
                    position: "relative",
                    aspectRatio: "4 / 3",
                    overflow: "hidden",
                    background: "#e5e7eb",
                  }}
                >
                  <img
                    src={item.cover}
                    alt={item.title}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: 12,
                      left: 12,
                      padding: "8px 12px",
                      borderRadius: 999,
                      background: "rgba(15,23,42,0.82)",
                      color: "#fff",
                      fontSize: 13,
                      fontWeight: 700,
                    }}
                  >
                    Před / Po
                  </div>
                </div>

                <div style={{ padding: 18 }}>
                  <div style={{ fontSize: 20, fontWeight: 800, color: "#0f172a", marginBottom: 8 }}>
                    {item.title}
                  </div>
                  <div style={{ color: "#475569", lineHeight: 1.7, fontSize: 15 }}>
                    {item.subtitle || "Ukázka dokončené práce"}
                  </div>
                  <div style={{ marginTop: 14, color: "#2563eb", fontWeight: 700 }}>
                    Zobrazit detail
                  </div>
                </div>
              </button>
            ))}
          </div>
        )}
      </div>

      {activeItem ? (
        <div
          onClick={() => setOpenIndex(null)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(2,6,23,0.78)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 20,
            zIndex: 9999,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "100%",
              maxWidth: 1100,
              maxHeight: "92vh",
              overflow: "auto",
              background: "#ffffff",
              borderRadius: 24,
              border: "1px solid #dbe7f5",
              boxShadow: "0 30px 80px rgba(15,23,42,0.35)",
              padding: 22,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: 12,
                alignItems: "flex-start",
                marginBottom: 18,
                flexWrap: "wrap",
              }}
            >
              <div>
                <div style={{ fontSize: 28, fontWeight: 800, color: "#0f172a", marginBottom: 8 }}>
                  {activeItem.title}
                </div>
                <div style={{ color: "#64748b", lineHeight: 1.7 }}>
                  {activeItem.subtitle}
                </div>
              </div>

              <button
                type="button"
                onClick={() => setOpenIndex(null)}
                style={{
                  padding: "12px 16px",
                  borderRadius: 14,
                  border: "1px solid #cbd5e1",
                  background: "#fff",
                  cursor: "pointer",
                  fontWeight: 700,
                }}
              >
                Zavřít
              </button>
            </div>

            <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 18 }}>
              {activeItem.before ? (
                <button
                  type="button"
                  onClick={() => setActiveTab("before")}
                  style={{
                    padding: "12px 16px",
                    borderRadius: 14,
                    border: activeTab === "before" ? "1px solid #2563eb" : "1px solid #cbd5e1",
                    background: activeTab === "before"
                      ? "linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)"
                      : "#fff",
                    color: activeTab === "before" ? "#fff" : "#0f172a",
                    fontWeight: 800,
                    cursor: "pointer",
                  }}
                >
                  Před údržbou
                </button>
              ) : null}

              {activeItem.after ? (
                <button
                  type="button"
                  onClick={() => setActiveTab("after")}
                  style={{
                    padding: "12px 16px",
                    borderRadius: 14,
                    border: activeTab === "after" ? "1px solid #2563eb" : "1px solid #cbd5e1",
                    background: activeTab === "after"
                      ? "linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)"
                      : "#fff",
                    color: activeTab === "after" ? "#fff" : "#0f172a",
                    fontWeight: 800,
                    cursor: "pointer",
                  }}
                >
                  Po údržbě
                </button>
              ) : null}
            </div>

            {activeImage ? (
              <div
                style={{
                  borderRadius: 20,
                  overflow: "hidden",
                  background: "#f8fafc",
                  border: "1px solid #e2e8f0",
                  marginBottom: 16,
                }}
              >
                <img
                  src={activeImage}
                  alt={`${activeItem.title} - ${activeTab === "before" ? "před" : "po"}`}
                  style={{
                    width: "100%",
                    height: "auto",
                    display: "block",
                    maxHeight: "68vh",
                    objectFit: "contain",
                    background: "#f8fafc",
                  }}
                />
              </div>
            ) : null}

            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 12 }}>
              {[
                { key: "before", label: "Před údržbou", src: activeItem.before },
                { key: "after", label: "Po údržbě", src: activeItem.after },
              ]
                .filter((x) => x.src)
                .map((thumb) => (
                  <button
                    key={thumb.key}
                    type="button"
                    onClick={() => setActiveTab(thumb.key)}
                    style={{
                      padding: 0,
                      borderRadius: 16,
                      overflow: "hidden",
                      border: activeTab === thumb.key ? "2px solid #2563eb" : "1px solid #cbd5e1",
                      background: "#fff",
                      cursor: "pointer",
                    }}
                  >
                    <div style={{ aspectRatio: "4 / 3", background: "#e5e7eb" }}>
                      <img
                        src={thumb.src}
                        alt={thumb.label}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          display: "block",
                        }}
                      />
                    </div>
                    <div style={{ padding: 10, fontWeight: 700, color: "#0f172a" }}>
                      {thumb.label}
                    </div>
                  </button>
                ))}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
